// extracted by mini-css-extract-plugin
export default {"image":"TY-z","loaded":"UY-z"};